import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const KEY = "la-theme";

export function applyStoredTheme() {
  document.documentElement.classList.toggle("light", localStorage.getItem(KEY) === "light");
}

export const ThemeToggle = ({ className = "" }) => {
  const [light, setLight] = useState(() => localStorage.getItem(KEY) === "light");
  useEffect(() => {
    document.documentElement.classList.toggle("light", light);
    localStorage.setItem(KEY, light ? "light" : "dark");
  }, [light]);
  return (
    <button
      data-testid="theme-toggle"
      onClick={() => setLight((v) => !v)}
      title={light ? "Mudar para tela escura" : "Mudar para tela clara"}
      className={`flex items-center gap-1.5 rounded-full border border-[#2D333F] px-2.5 py-1.5 text-xs text-[#9CA3AF] hover:border-[#E67E22] transition-colors ${className}`}
    >
      {light ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
      <span className="hidden sm:inline">{light ? "Tela escura" : "Tela clara"}</span>
    </button>
  );
};
